// keys.ts — RQ cache keys for the models suite. Private.

const MODELS_QUERY_KEY = {
  Root: 'models',
} as const;

export const modelsKeys = {
  all: [MODELS_QUERY_KEY.Root] as const,
};
